module.exports = __webpack_public_path__ + "static/media/footer-logo.42b3c97b.png";